module.exports = __webpack_public_path__ + "img/Maria.3269d73d.png";